import { TextLink } from '@moneyforward/ap-frontend-components';
import { Flex } from 'antd';
import { ApprovingInvoiceReportFormInputResponse } from 'ap-openapi';
import classnames from 'classnames/bind';
import { FC, memo, useMemo } from 'react';
import { processLabels } from '../../helper';
import styles from '../../styles.module.scss';

const cx = classnames.bind(styles);

type CombineLabelFieldViewWithLinkProps = {
  item: ApprovingInvoiceReportFormInputResponse;
};

export const CombineLabelFieldViewWithLink: FC<CombineLabelFieldViewWithLinkProps> =
  memo(({ item }) => {
    const processedLabels = useMemo(() => {
      return processLabels(item?.input_values || []);
    }, [item?.input_values]);

    if (processedLabels?.length === 0) {
      return null;
    }

    return (
      <Flex>
        {processedLabels?.map(({ id, label, value }, index) =>
          value ? (
            <TextLink
              className={cx('linkNoExtensionIcon')}
              target='_blank'
              key={id ?? `empty-view-combine-label-field-with-link-${index}`}
              href={value ?? ''}
            >
              {label ?? ''}
            </TextLink>
          ) : (
            <div
              key={
                id ?? `empty-view-combine-label-field-with-link-div-${index}`
              }
            >
              {label ?? ''}
            </div>
          )
        )}
      </Flex>
    );
  });

CombineLabelFieldViewWithLink.displayName = 'CombineLabelFieldViewWithLink';
